import { axios } from '@/lib/axios/axios';
import { MESSAGING_API_BASE } from '../config';

export type ConfirmUploadBody = {
  s3Key: string;
  fileName: string;
};

export type ConfirmUploadResponse = {
  storedFileId: number;
  accessKey: string;
  thumbnail: { accessKey: string; width: number; height: number } | null;
};

export const confirmUpload = async (
  body: ConfirmUploadBody
): Promise<ConfirmUploadResponse> => {
  // Backend expects hyphenated keys 's3-key' and 'file-name'
  const payload = {
    's3-key': body.s3Key,
    'file-name': body.fileName,
  } as any;

  return axios.post(`${MESSAGING_API_BASE}/files/confirm-upload`, payload);
};

export const useConfirmUpload = () => {
  return { confirmUpload };
};
